import React from 'react'
import { Toast } from 'antd-mobile'
import ClipboardComponent from 'react-clipboard.js'
import cz from 'classnames'
import styles from './styles.module.scss'
import TrackContainer from '../TrackContainer'
import FailMessage from '../FailMessage'

interface ClipboardProps {
  value: string | number
  track?: {
    trackId: string;
    properties?: object;
  },
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
  onSuccess?(): void
}

const Clipboard: React.FC<ClipboardProps> = (props) => {
  const { value, className, style, children, onSuccess, track } = props
  return (
    <TrackContainer trackId="h5_share_copy" {...track}>
      <ClipboardComponent
        style={style}
        className={cz(
          'pure-btn',
          {
            'color-orange': !className,
            [styles['copy-btn']]: !className,
          },
          className
        )}
        data-clipboard-text={value}
        onSuccess={() => {
          if (onSuccess) {
            return onSuccess()
          }
          Toast.success('已复制到剪贴板', 2)
        }}
        onError={() => Toast.show(<FailMessage>复制失败</FailMessage>, 2)}
      >
        {children}
      </ClipboardComponent>
    </TrackContainer>
  )
}

export default Clipboard
